import Button from "../../../Components/Button";
import { IAdditional } from "../../TableTemplate/tableTemplate";
import { TableCell } from "@mui/material";
import { useContext, useState } from "react";
import {
  IProfileTableRow,
  ITimeConfigTableReport,
} from "src/Interfaces/deltaHedgeBackTest";
import { Edit } from "@mui/icons-material";
import { Modal } from "src/Components";
import AddProfile from "src/Pages/DeltaHedgeBackTest/AddProfile";
import { RefreshFlagContext } from "src/Pages/DeltaHedgeBackTest";

const TableAdditionalHeader: React.FC = ({}) => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">ویرایش</span>
      </TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: ITimeConfigTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { setRefreshFlag } = useContext(RefreshFlagContext);

  return (
    <>
      <TableCell>
        {isEditModalOpen ? (
          <Modal
            title="ویرایش"
            onClose={() => setIsEditModalOpen(false)}
            modalBoxClassName="!min-w-[250px]"
            UI={
              <AddProfile
                onClose={() => {
                  setIsEditModalOpen(false);
                  setRefreshFlag(true);
                }}
                editValues={{
                  profileName: row.profileName,
                  searchParam: null as any,
                  timeConfig: {
                    minDEI: row.minDei,
                    minTE: row.te,
                    resolutionInMins: row.resolutionInMins,
                    windowLengthInDays: row.windowLengthInDays,
                  },
                }}
              />
            }
          />
        ) : (
          <></>
        )}
        <div className="w-min">
          <Button
            text={<Edit />}
            variant="contained"
            onClick={() => setIsEditModalOpen(true)}
            className="table-btn"
          />
        </div>
      </TableCell>
    </>
  );
};

export const TableAdditional: IAdditional<ITimeConfigTableReport> = {
  getHeader: TableAdditionalHeader,
  getRow: AdditionalCol,
};
